import axios from "axios";

export default axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://glacial-dawn-50698.herokuapp.com/api"
      : "http://localhost:8080/api",
});
